import { Trans } from "react-i18next";

export function PharmacyPickerAvailableCount({
	count,
	total,
}: {
	count: number;
	total: number;
}) {
	return (
		<p
			className="text-body-sm text-gray-700"
			data-testid="pharmacy-picker-available-count"
		>
			<Trans
				ns="product"
				i18nKey="vendor.picker.availableCount"
				values={{ count, total }}
				components={{ bold: <span className="text-body-sm-emphasis" /> }}
			/>
		</p>
	);
}
